/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import {  } from "relay-runtime";
export type SiteNavDropdownContent_navigationModule = {
    readonly name: string | null;
    readonly items: ReadonlyArray<{
        readonly name: string | null;
        readonly column: string | null;
        readonly items: ReadonlyArray<{
            readonly name: string | null;
            readonly linkData: {
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
            };
        } | null> | null;
    } | null> | null;
    readonly imageUrl: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownImageModule_navigationModule">;
    readonly " $refType": "SiteNavDropdownContent_navigationModule";
};
export type SiteNavDropdownContent_navigationModule$data = SiteNavDropdownContent_navigationModule;
export type SiteNavDropdownContent_navigationModule$key = {
    readonly " $data"?: SiteNavDropdownContent_navigationModule$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SiteNavDropdownContent_navigationModule">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SiteNavDropdownContent_navigationModule",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "NavigationTopLevel",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "column",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "NavigationItem",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "LinkData",
                                "kind": "LinkedField",
                                "name": "linkData",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "SeoLink_linkData"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "imageUrl",
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SiteNavDropdownImageModule_navigationModule"
            }
        ],
        "type": "NavigationModule",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '29cf467b177d1c4a3decf224806f52f9';
export default node;
